module.exports = __webpack_public_path__ + "img/ab-page4-tj.081f4c97.png";